import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getAdminDevices = async () => {
  const signedRequest = await createSignedGetRequest({
    apiPath: 'admin/renolog/devices',
    //isLocalApiRequest: true,
  });
  const response = await axios(signedRequest);
  return response.data;
};
